import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  label: {
    minHeight: "25.6px",
    color: theme.palette.primaryGrey,
    ...theme.typography.h6,
    marginBottom: "8px"
  } 
}));